export const auth = {
  namespaced: true,
  state: {
    authWallet: {
      status: 1,
      options: {
        LOGGED_IN: 0, // logueado, sesion iniciada  o conectado
        LOGGING_IN: 1, // logueando, iniciando sesion o conectando
        NOT_LOGGED_IN: 2 // sin iniciar sesion
      }
    }
  },
  actions: {
    async logoutWallet ({ state, commit }) {
      console.log('logoutWallet')
      localStorage.ADDRESS = ''
      localStorage.LOGGED_IN = state.authWallet.options.LOGGING_IN
      await commit('setStatusAuthWallet', state.authWallet.options.LOGGING_IN)
      commit('setStatusAuthWallet', state.authWallet.options.NOT_LOGGED_IN)
    },
    async reset ({ state, commit }) {
      console.log('reset')
      localStorage.ADDRESS = ''
      localStorage.LOGGED_IN = state.authWallet.options.LOGGING_IN
      await commit('setStatusAuthWallet', state.authWallet.options.LOGGING_IN)
    },
    async loggedIn ({ state, commit }) {
      console.log('auth logged in')
      localStorage.ADDRESS = ''
      localStorage.LOGGED_IN = state.authWallet.options.LOGGING_IN
      await commit('setStatusAuthWallet', state.authWallet.options.LOGGING_IN)
      commit('setStatusAuthWallet', state.authWallet.options.LOGGED_IN)
    }
  },
  mutations: {
    setStatusAuthWallet (state, status) {
      state.authWallet.status = status
    }
  },
  getters: {
    getStatusAuthWallet: state => state.authWallet.status,
    getOptionsAuthWallet: state => state.authWallet.options
  }
}
